<template>
    <b-input-group class="assign-select">
        <multiselect
                :options="reviewers"
                label="label"
                v-model="selected"
                @input="onInput"
                group-label="team"
                group-values="items"
                :group-select="false"
                selectLabel=""
                placeholder=""
                tagPlaceholder=" "
                deselectLabel=""
                :disabled="disabled"
                ref="assignselect"
        >
            <template #caret="{ toggle }">
                <caret-icon @mousedown.prevent.stop="toggle"></caret-icon>
            </template>
        </multiselect>
        <b-input-group-append v-if="confirmButtons && allowed" class="transparent">
            <b-btn
                    v-if="disabled"
                    @click="disabled = false"
            >
                <font-awesome-icon
                        :icon="['far', 'pencil']"
                        size="sm"
                >
                </font-awesome-icon>
            </b-btn>
            <b-btn
                    v-if="!disabled && !loading"
                    @click="onConfirm"
            >
                <font-awesome-icon
                        :icon="['fal', 'check']"
                        class="green"
                        size="sm"
                >
                </font-awesome-icon>
            </b-btn>
            <b-btn
                    v-if="!disabled && !loading"
                    @click="onCancel"
            >
                <font-awesome-icon
                        :icon="['far', 'times']"
                        class="red"
                        size="sm"
                >
                </font-awesome-icon>
            </b-btn>
            <b-btn
                    v-if="loading"
            >
                <font-awesome-icon
                        :icon="['fal', 'spinner']"
                        size="sm"
                        spin
                >
                </font-awesome-icon>
            </b-btn>
        </b-input-group-append>
    </b-input-group>
</template>

<script>
import ActionAssign from '@/services/Action/ActionAssign';

export default {
  name: 'Assign-Select',
  inheritAttrs: false,
  props: {
    options: {},
    value: {},
    confirmButtons: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      allowed: false,
      disabled: false,
      selected: null,
      originalSelected: null,
      reviewers: [],
    };
  },

  watch: {
    value: {
      handler(newValue) {
        this.selected = newValue;
        this.originalSelected = newValue;
      },
      immediate: true,
      deep: true,
    },
    options(newOptions) {
      this.reviewers = newOptions;
    },
    confirmButtons: {
      handler(newConfirmButtons) {
        this.allowed = newConfirmButtons;
      },
      immediate: true,
    },
  },

  mounted() {
    if (!this.options) {
      this.setAssignOptions();
    } else {
      this.reviewers = this.options;
    }

    if (this.confirmButtons) {
      this.disabled = true;
    }
  },

  methods: {
    setAssignOptions() {
      this.loading = true;
      ActionAssign.getFormattedOptions().then((options) => {
        this.reviewers = options;
        this.loading = false;
      });
    },
    onCancel() {
      this.selected = this.originalSelected;
      this.disable();
    },
    onConfirm() {
      this.$emit('input', this.selected);
      this.$emit('confirm', this.selected);
    },
    disable() {
      this.disabled = true;

      // not in official api but fixes IE11 not deactivating
      this.$refs.assignselect.deactivate();
    },
    onInput(value) {
      if (!this.confirmButtons && !this.disabled) {
        this.$emit('input', value);
      }
    }
  },
};
</script>

<style lang="scss">
.assign-select {
    .multiselect__option {
        padding-left: 25px;

        &--disabled {
            padding-left: 10px;
        }
    }
    @media screen and (max-width: 555px) {
        .multiselect__caret {
            display: none;
        }
    }
}
</style>
